module.exports = __webpack_public_path__ + "img/icon-filter.8116c3a8.svg";